import { useState } from 'react';
import { fetchFormations } from '../../services/api';
import { createFormation, updateFormation, deleteFormation } from '../../services/adminApi';
import { useCrudResource } from '../../hooks/useCrudResource';
import Button from '../../components/admin/ui/Button';
import Loader from '../../components/admin/ui/Loader';
import EntityTable from '../../components/admin/EntityTable';
import EntityForm from '../../components/admin/EntityForm';
import EntityFormPage from '../../components/admin/EntityFormPage';
import { formationColumns, formationFields } from '../../config/admin/formations.config';
import { extractYear } from '../../utils/extractYear';

function AdminFormationsPage({ showToast }) {
  const { items: formations, loading, createItem, updateItem, removeItem } = useCrudResource(
    { fetchAll: fetchFormations, create: createFormation, update: updateFormation, remove: deleteFormation },
    { showToast, entityLabel: 'Formation' }
  );
  const [editing, setEditing] = useState(null);
  const [view, setView] = useState('list');

  const openCreate = () => {
    setEditing(null);
    setView('form');
  };

  const openEdit = (formation) => {
    setEditing(formation);
    setView('form');
  };

  const handleSubmit = async (values) => {
    if (editing) {
      await updateItem(editing.id, values);
    } else {
      await createItem(values);
    }
    setView('list');
  };

  const handleDelete = async (formation) => {
    if (!window.confirm('Supprimer cette formation ?')) return;
    await removeItem(formation.id);
  };

  if (loading) return <Loader label="Chargement des formations..." />;

  if (view === 'form') {
    return (
      <EntityFormPage
        listLabel="Formations"
        itemLabel={editing ? editing.title?.fr || editing.title?.en : null}
        title={editing ? 'Modifier la formation' : 'Ajouter une formation'}
        onBack={() => setView('list')}
      >
        <EntityForm
          key={editing?.id ?? 'new'}
          fields={formationFields}
          initialValues={editing || {}}
          onSubmit={handleSubmit}
          submitLabel={editing ? 'Sauvegarder' : 'Créer'}
        />
      </EntityFormPage>
    );
  }

  return (
    <section className="admin-section">
      <div className="admin-actions" style={{ justifyContent: 'space-between', marginBottom: 'var(--space-3)' }}>
        <h2>Formations</h2>
        <Button onClick={openCreate}>+ Ajouter</Button>
      </div>

      <EntityTable
        columns={formationColumns}
        rows={formations}
        onEdit={openEdit}
        onDelete={handleDelete}
        emptyMessage="Aucune formation."
        searchPlaceholder="Rechercher une formation..."
        searchFilter={(row, needle) =>
          (row.title?.fr || '').toLowerCase().includes(needle) || (row.title?.en || '').toLowerCase().includes(needle)
        }
        yearRangeFilter={{ getYear: (row) => extractYear(row.date?.fr) }}
      />
    </section>
  );
}

export default AdminFormationsPage;
